import React from 'react';
import { List, Datagrid, TextField, NumberField, useListContext, Link } from 'react-admin';
import Typography from '@material-ui/core/Typography';

import SearchAside from './SearchAside';
import useSupplyStyles from '../controls/SupplyStyles';
import ErrorBoundary from '../ErrorBoundary';

/** "6 TYPES OF SUPPLIES FOUND IN INVENTORY." */
const FoundHeader = () => {
    const classes = useSupplyStyles();
    const { total } = useListContext();
    return (
        <Typography className={classes.sectionTitle}>
             <span style={{marginLeft: 16 }}>{total || 0} type{total === 1 ? '' : 's'} of supplies found in inventory.</span>
        </Typography>
    );
};

/** Supply type drills into the lot list for that type. */
const SupplyTypeLinkField = ({ record }) =>
    record ? (
        <Link
            to={{
                pathname: '/supplylots',
                search: `filter=${JSON.stringify({ supply_type_id: record.supply_type_id })}`,
            }}
        >
            {record.supply_type}
        </Link>
    ) : null;

SupplyTypeLinkField.defaultProps = { label: 'Supply Type', source: 'supply_type' };

const InventoryContent = props => (
    <React.Fragment>
        <FoundHeader />
        <Datagrid {...props}>
            <SupplyTypeLinkField />
            <NumberField source="qty_qa_pending" label="QA Pending" />
            <NumberField source="qty_reserve" label="Reserve" />
            <NumberField source="qty_release" label="Release" />
            <NumberField source="qty_rel_sublot" label="Release Sublot" />
            <NumberField source="qty_transfer" label="Transfer" />
            <NumberField source="qty_hold" label="Hold" />
            <NumberField source="qty_total" label="Total" />
            <TextField source="uom" label="UOM" />
        </Datagrid>
    </React.Fragment>
);

const SupplyInventoryList = props => {
    const classes = useSupplyStyles();
    return (
        <ErrorBoundary>
            <List
                {...props}
                title="Supply Inventory Summary"
                classes={{ main: classes.asideLeft }}
                filterDefaultValues={{ category_id: 1 }}
                perPage={25}
                sort={{ field: 'supply_type', order: 'ASC' }}
                bulkActionButtons={false}
                empty={false}
                exporter={false}
            >
                <InventoryContent />
            </List>
        </ErrorBoundary>
    );
};

export default SupplyInventoryList;
